import React from 'react';
import _ from 'lodash';
import M from 'materialize-css';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import NavBarLateral from '../NavBarLateral/index';
import './css/styles.css';

class AdminEspeciales extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            especiales: [],
            estados: {
                importancia1: false,
                importancia2: false,
                importancia3: false,
                eliminar: false,
            },
            isLogged: this.props.auth,
            adminError: false,
            adminExitoso: false,
            descripcionError: '',
            descripcionExitoso: '',
        };
        this.deleteProject = this.deleteProject.bind(this);
        this.saveImportants = this.saveImportants.bind(this);
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        M.AutoInit();
        document.body.style.backgroundImage = 'none';
        fetch('/api/uip/especiales', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(response => {
                let res = [];
                let arraySwitchs = [];
                res = _.map(response, especial => {
                    _.map(_.keys(this.state.estados), estado  => {
                        let objs = {};
                        objs = {
                            _id: especial._id,
                            tipo: estado,
                            estado: false,
                        };
                        if(especial.importancia === "1" && estado==="importancia1"){
                            objs.estado = true;
                        }
                        if(especial.importancia === "2" && estado==="importancia2"){
                            objs.estado = true;
                        }
                        if(especial.importancia === "3" && estado==="importancia3"){
                            objs.estado = true;
                        }
                        arraySwitchs.push(objs);
                    });
                    especial.delete = false;
                    especial.arraySwitchs = arraySwitchs;
                    arraySwitchs = [];
                    return especial;
                });
                this.setState({ especiales: res });
            })
            .catch(err => console.log(err))
    }

    getStateSwitch(sw) {
        let especiales = [];
        let array = [];
        //console.log(document.getElementById(`${sw._id}-${sw.tipo}`));
        especiales = _.map(this.state.especiales, especial => {
            if(especial._id === sw._id){
                array = _.map(especial.arraySwitchs, item => {
                    if(item.tipo === sw.tipo){
                        item.estado =  !item.estado;
                        return item;
                    }
                    return item;
                });
                especial.arraySwitchs = array;
                return especial;
            }
            return especial;
        })
        this.setState({especiales: especiales});
    }

    deleteProject() {
        let cantidad = 0;
        let id;
        _.map(this.state.especiales, especial => {
            _.map(especial.arraySwitchs, switchs => {
                if(switchs.tipo === "eliminar" && switchs.estado === true){
                    cantidad ++;
                    id = switchs._id;
                }
            });
        });
        if(cantidad === 1){
            fetch('/api/uip/especiales/' + id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    this.setState({
                        adminExitoso: true,
                        descripcionExitoso: 'Se elimino el proyecto exitosamente',
                    })
                })
                .catch(err => console.log(err.message))
        }
        if(cantidad < 1){
            this.setState({
                adminError: true,
                descripcionError: 'Seleccionar al menos un proyecto para eliminar',
            });
        }
        if(cantidad > 1){
            this.setState({
                adminError: true,
                descripcionError: 'Solo se puede eliminar un proyecto a la vez',
            });
        }
    }

    saveImportants(){
        let numeroImportantes1 = 0;
        let numeroImportantes2 = 0;
        let numeroImportantes3 = 0;
        let actualizarImportantes = {};
        let importantesNuevos = new Array(3);
        _.map(this.state.especiales, especial => {
            _.map(especial.arraySwitchs, sw => {
                if(sw.tipo === "importancia1" && sw.estado === true) {
                    numeroImportantes1++;
                    importantesNuevos[0] = {
                        _id: sw._id,
                        importancia: '1',
                    };
                }
                if(sw.tipo === "importancia2" && sw.estado === true) {
                    numeroImportantes2++;
                    importantesNuevos[1] = {
                        _id: sw._id,
                        importancia: '2',
                    };
                }
                if(sw.tipo === "importancia3" && sw.estado === true) {
                    numeroImportantes3++;
                    importantesNuevos[2] = {
                        _id: sw._id,
                        importancia: '3',
                    };
                }
                
            })
        });
        if(numeroImportantes1 > 1){
            this.setState({
                adminError: true,
                descripcionError: 'Solo puede existir un proyecto importante1',
            });
        }
        if(numeroImportantes1 < 1){
            this.setState({
                adminError: true,
                descripcionError: 'Debe existir al menos un proyecto importante1',
            });
        }
        if(numeroImportantes2 > 1){
            this.setState({
                adminError: true,
                descripcionError: 'Solo puede existir un proyecto importante2',
            });
        }
        if(numeroImportantes2 < 1){
            this.setState({
                adminError: true,
                descripcionError: 'Debe existir al menos un proyecto importante2',
            });
        }
        if(numeroImportantes3 > 1){
            this.setState({
                adminError: true,
                descripcionError: 'Solo puede existir un proyecto importante3',
            });
        }
        if(numeroImportantes3 < 1){
            this.setState({
                adminError: true,
                descripcionError: 'Debe existir al menos un proyecto importante3',
            });
        }
        if(numeroImportantes1 === 1 &&
           numeroImportantes2 === 1 &&
           numeroImportantes3 === 1){
            actualizarImportantes.importantesNuevos = importantesNuevos;
            console.log(actualizarImportantes);
            fetch('/api/uip/especiales/actualizar/importantes',{
                headers:{
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(actualizarImportantes)
            })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    adminExitoso: true,
                    descripcionExitoso: 'Se actualizaron los proyectos importantes exitosamente',
                })
            })
            .catch(err => console.log(err))
        }
    }

    render() {

        if(this.state.adminError === true){
            return(
                <Redirect 
                    to={{
                        pathname: '/administrador/error/general',
                        state: { 
                            descripcionError: this.state.descripcionError,
                            rutaRegreso: '/administrador/especiales' 
                        }
                    }}
                />
           );
        }

        if(this.state.adminExitoso === true){
            return(
                <Redirect 
                    to={{
                        pathname: '/administrador/proceso/exitoso',
                        state: { 
                            descripcionError: this.state.descripcionExitoso,
                            rutaRegreso: '/administrador/especiales' 
                        }
                    }}
                />
           );
        }

        let count = 1;
        const objEsp = [];
        const objetosEsp = _.map(this.state.especiales, (especial, i) => {

            let listaSwitch = _.map(especial.arraySwitchs, (sw, j) => {
                const unSw = <Switch
                                _id={sw._id}
                                switchs={sw}
                                callback={this.getStateSwitch.bind(this)} 
                                key={j}/>;
                const cuatroSw = <ListaSwitch 
                                    tipo={sw.tipo}
                                    switch={unSw}/>
                return <li>{cuatroSw}</li>;
            });

            const listaItems = <ul>{listaSwitch}</ul>;

            if(count === 1){
                objEsp[0] =
                    <CardAdmin
                        titulo={especial.titulo}
                        frase={especial.frase}
                        index={especial.index}
                        id={especial._id}
                        listasw={listaItems}
                        key={i} />
                
                count = count + 1;

                if(this.state.especiales.length===(i+1)){
                    return(
                        <div className="row">
                            {objEsp[0]}
                        </div>
                    );
                }
            }
            else if(count === 3){
                objEsp[2] =
                    <CardAdmin
                        titulo={especial.titulo}
                        frase={especial.frase}
                        index={especial.index}
                        id={especial._id}
                        listasw={listaItems}
                        key={i} />
                
                count = 1;

                return(
                    <div className="row">
                        {objEsp[0]}
                        {objEsp[1]}
                        {objEsp[2]}
                    </div>
                );
            }
            else {
                objEsp[1] =
                    <CardAdmin
                        titulo={especial.titulo}
                        frase={especial.frase}
                        index={especial.index}
                        id={especial._id}
                        listasw={listaItems}
                        key={i} />
                
                count = count + 1;

                if(this.state.especiales.length===(i+1)){
                    return(
                        <div className="row pd-botton-18 pd-top-18">
                            {objEsp[0]}
                            {objEsp[1]}
                        </div>
                    );
                }
            }
        })

        if(this.state.isLogged === true){
            return (
                <div>
                    <NavBarLateral 
                        isLogged={this.state.isLogged}/>
                    <div className={`pad`}>
                        <div className={`row`}>
                            <NavTitulo 
                                cantidad={this.state.especiales.length}/>
                        </div>
                        <div className={`row`}>
                            <br />
                            <div className={`col s12 m4 center-align`}>
                                <Link to="/administrador/especiales/nuevo">
                                    <a className="waves-effect waves-light btn-large"><i className="material-icons left">add_box</i>Crear Proyecto</a>
                                </Link>
                            </div>
                            <div className={`col s12 m4 center-align`}>
                                <button
                                    className="btn waves-effect waves-light btn-large"
                                    type="submit"
                                    name="action"
                                    onClick={this.saveImportants}>
                                    <i className="material-icons left">save</i>
                                    Guardar Importantes
                                </button>
                            </div>
                            <div className={`col s12 m4 center-align`}>
                                <button
                                    className="btn waves-effect waves-light btn-large red lighten-1"
                                    type="submit"
                                    name="action"
                                    onClick={this.deleteProject}>
                                    <i className="material-icons left">delete_forever</i>
                                    Eliminar Proyecto
                                </button>
                            </div>
                            <br />
                        </div>
                        {objetosEsp}
                    </div>
                </div>

            );
        }
        else {
            return <Redirect to="/administrador/login"/>
        }
    }
}

class CardAdmin extends React.Component {

    render() {
        return (
            <div className="col s12 m4">
                <div className={`row`}>
                    <div className={`col s12 m12`}>
                        <div className={`card hoverable`}>
                            <div className="card-image">
                                <img src={this.props.index} className={`border-img`} />
                            </div>
                            <div className="card-content">
                                <span className="card-title custom-fontAdminEspTitle">{this.props.titulo}</span>
                                <p className={`custom-fontAdminEspText`}>{this.props.frase}</p>
                            </div>
                            <div className="card-action">
                                <div className={`row valign-wrapper`}>
                                    <div className={`col s12 m6 left-align`}>
                                        <span>Editar</span>
                                    </div>
                                    <div className={`col s12 m6 right-align`}>
                                        {console.log(this.props.id)}
                                        <Link to={{
                                            pathname: '/administrador/especiales/actualizar',
                                            state: {
                                                id: this.props.id,
                                            }
                                        }}>
                                            <a className="waves-effect waves-light btn light-blue btn-small">
                                                <i className="material-icons right">send</i>
                                                ir
                                            </a>
                                        </Link>
                                    </div>
                                </div>
                                {this.props.listasw}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class ListaSwitch extends React.Component{
    render(){
        return(
            <div className={`row valign-wrapper`}>
                <div className={`col s12 m6 left-align`}>
                    <span>{this.props.tipo}</span>
                </div>
                <div className={`col s12 m6 right-align`}>
                    {this.props.switch}
                </div>
            </div>
        );
    }
}

class Switch extends React.Component {

    getStateSwitch(){
        this.props.callback(this.props.switchs);
    }

    render() {
        return (
            <div className="switch"
                id={`${this.props.switchs._id}-${this.props.switchs.tipo}`}>
                <label>
                Off
                <input 
                    type="checkbox" 
                    defaultChecked={this.props.switchs.estado} 
                    onClick={() => this.getStateSwitch()} />
                <span className="lever"></span>
                On
                </label>
            </div>
        );
    }
}

class NavTitulo extends React.Component{
    render(){
        return(
            <div className="navbar-fixed">
                <nav className="light-blue">
                    <div className="nav-wrapper">
                        <a className="brand-logo margin-titulo-especiales">
                            Especiales
                            <span 
                                className="new badge red lighten-1 margin-badge-nav"
                                data-badge-caption="proyectos">
                                {this.props.cantidad}
                            </span>
                        </a>
                    </div>
                </nav>
            </div>
         
        );
    }
}

export default AdminEspeciales;